import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import headerImg from "./10.jpg";
import books from "./books.png";
import { Icon } from "@iconify/react";
import useResponsive from "../../../../../Hooks/useResponsive";
import { useSelector } from "react-redux";

const EditHeader = () => {
  const { cartEditData, loading } = useSelector((state) => state.cart);
  const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");
  return (
    <Box sx={{ p: 2 }}>
      <Paper
        elevation={3}
        sx={{
          height: smUp ? 250 : "auto",
          padding: 2,
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            height: 150,
            backgroundImage: `url(${headerImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            borderRadius: 3,
          }}
        ></Box>

        <Box sx={{ position: "relative", top: -50, p: 3 }}>
          <Stack direction={"row"}>
            <img src={books} alt="Header" height={80} width={80} />
            <Box sx={{ mt: 4, ml: 1 }}>
              <Typography variant="h6">
                {(cartEditData.course_available?.course_name &&
                  cartEditData.course_available.course_name.replace(
                    /[_-]/g,
                    " "
                  )) ||
                  "Course not found"}
              </Typography>

              <Box>
                <Chip
                  icon={
                    <Icon
                      icon="eos-icons:project-outlined"
                      width="15"
                      height="15"
                    />
                  }
                  size="small"
                  variant="outlined"
                  label={
                    cartEditData?.course_available?.project?.project_name ||
                    "Project not available"
                  }
                />
              </Box>
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default EditHeader;
